import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { Row, Col } from 'react-bootstrap'
import { useLazyQuery } from '@apollo/client'

import styles from './style.module.scss'
import { payload } from '@shared/libs/category'
import { isBottomReached } from '@shared-submodule/utils'
import { GET_TAG_ARTICLE } from '@graphql/tag/tag.query'
import { articleLoader } from '@shared/libs/allLoader'

// const ArticleBig = dynamic(() => import('@shared/components/article/articleBig'), { loading: () => articleLoader(['g']) })
const ArticleMedium = dynamic(() => import('@shared/components/article/articleMedium'), { loading: () => articleLoader(['s']) })

const NoData = dynamic(() => import('@shared/components/noData'), { ssr: false })

const PlayerNews = ({ data, category, hideBadge, isClientOnly, playerData }) => {
  const [newsData, setNewsData] = useState(data?.aResults || [])
  const loading = useRef(false)
  const payloadNews = useRef({ ...payload(7) })
  const [isLoading, setIsLoading] = useState(false)

  const [tagArticle, { data: tagArticles, tLoading }] = useLazyQuery(GET_TAG_ARTICLE)

  const latestNews = useRef(getLengthForPagination())

  useEffect(() => {
    loading.current = false
    setIsLoading(false)
    latestNews.current = getLengthForPagination()
    if (newsData?.length) isBottomReached(newsData[newsData.length - 1]?._id, isReached)
  }, [newsData])

  useEffect(() => {
    const value = tagArticles?.getTagArticlesFront
    if (value && value?.aResults?.length !== 0) {
      setNewsData([...newsData, ...value?.aResults])
    }
  }, [tagArticles])

  async function isReached(reach) {
    if (reach && !loading.current && (latestNews.current === 7 || latestNews.current === 16)) {
      setIsLoading(true)
      loading.current = true
      setPayload()
      getMoreData()
    }
  }

  async function getMoreData() {
    const { data } = await tagArticle({ variables: { input: { _id: playerData?._id, eType: 'p', ...payloadNews.current } } })
    return data?.getTagArticlesFront?.aResults
  }

  function setPayload(isTag) {
    payloadNews.current = { ...payloadNews.current, eType: 'p', nSkip: payloadNews.current.nSkip + 1 }
  }

  function getLengthForPagination() {
    return (
      tagArticles?.getTagArticlesFront?.aResults?.length ||
      data?.aResults?.length
    )
  }

  return (
    <>
      {newsData?.length !== 0 && (
        <div className={styles.seriesHome}>
          <Row className='content-visibility-auto'>
            {newsData?.map((news, i) => {
              return (
                <Col key={news?._id} md={12} id={news?._id}>
                  <ArticleMedium key={news._id} data={news} />
                </Col>
              )
            })}
          </Row>
          {isLoading && articleLoader(['s', 's'])}
        </div>
      )}
      {(!tLoading || !isLoading) && newsData?.length === 0 && <NoData />}
    </>
  )
}

PlayerNews.propTypes = {
  data: PropTypes.object,
  category: PropTypes.object,
  playerData: PropTypes.object,
  hideBadge: PropTypes.bool,
  isClientOnly: PropTypes.bool
}

export default PlayerNews
